/**
 * Fiche produit : autoplay muet lorsque le média vidéo entre dans le viewport ;
 * pause quand il en sort. Bouton pour activer / couper le son.
 *
 * Ne pas filtrer par .product-gallery : absent du template product-default.
 */
(function ($) {
  'use strict';

  if (!$ || !document.body || !document.body.classList.contains('template-product')) {
    return;
  }

  /** Part du bloc média visible avant déclenchement (0–1). */
  var VISIBILITY_THRESHOLD = 0.2;

  var ICON_MUTED =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"/><path stroke-linecap="round" stroke-linejoin="round" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"/></svg>';

  var ICON_SOUND =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"/></svg>';

  var ICON_FULLSCREEN =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/></svg>';

  var ICON_CLOSE_OVERLAY =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>';

  var visibilityObserver = null;
  var nlFsEscListener = null;
  /** Évite double déclenchement click + touchend (iOS). */
  var nlFsLastGestureMs = 0;

  function nlFsGestureDebounced(run) {
    var now = Date.now();
    if (now - nlFsLastGestureMs < 420) return;
    nlFsLastGestureMs = now;
    run();
  }

  function updateSoundButton(btn, muted) {
    if (!btn) return;
    btn.classList.toggle('nl-product-video-sound--muted', muted);
    btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    btn.setAttribute('aria-label', muted ? 'Activer le son' : 'Couper le son');
    btn.innerHTML = muted ? ICON_MUTED : ICON_SOUND;
  }

  function ensureSoundBtn(container) {
    if (!container || !container.querySelector('.productView-video')) return null;
    var existing = container.querySelector('.nl-product-video-sound');
    if (existing) return existing;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nl-product-video-sound nl-product-video-sound--muted';
    btn.setAttribute('aria-label', 'Activer le son');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = ICON_MUTED;
    container.appendChild(btn);
    return btn;
  }

  function videoFullscreenLabel() {
    return (window.nlProductMedia && window.nlProductMedia.videoFullscreenLabel) || 'Plein écran';
  }

  function resolveFullscreenLightboxSrc(containerEl) {
    var $wrap = $(containerEl);
    var $vid = $wrap.find('.productView-video').first();
    if (!$vid.length) return null;

    if ($vid.hasClass('youtube')) {
      var id = $vid.data('video-url') || $vid.find('[data-youtube]').data('youtube');
      return id ? 'https://www.youtube.com/watch?v=' + id : null;
    }

    if ($vid.hasClass('vimeo')) {
      var iframe = $vid.find('iframe')[0];
      if (!iframe || !iframe.src) return null;
      var m = iframe.src.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      return m ? 'https://vimeo.com/' + m[1] : null;
    }

    if ($vid.hasClass('mp4')) {
      var videoEl = $vid.find('video')[0];
      if (!videoEl) return null;
      var u = videoEl.currentSrc;
      if (!u) {
        var srcEl = videoEl.querySelector('source[src]');
        u = srcEl ? srcEl.getAttribute('src') : '';
      }
      return u || null;
    }

    return null;
  }

  function ensureFullscreenBtn(container) {
    if (!container || !container.querySelector('.productView-video')) return null;

    var fancyOn =
      typeof $.fancybox === 'function' &&
      window.nlProductMedia &&
      window.nlProductMedia.galleryUsesFancybox === true;
    var lbSrc = fancyOn ? resolveFullscreenLightboxSrc(container) : null;

    var existing = container.querySelector('.nl-product-video-fullscreen');
    if (existing) {
      if (fancyOn && lbSrc && !existing.getAttribute('data-fs-src')) {
        existing.setAttribute('data-fs-lightbox', '1');
        existing.setAttribute('data-fs-src', lbSrc);
      }
      return existing;
    }

    var label = videoFullscreenLabel();
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nl-product-video-fullscreen';
    btn.setAttribute('aria-label', label);

    if (fancyOn && lbSrc) {
      btn.setAttribute('data-fs-lightbox', '1');
      btn.setAttribute('data-fs-src', lbSrc);
    }

    btn.innerHTML = ICON_FULLSCREEN + '<span class="visually-hidden">' + label + '</span>';

    var soundBtn = container.querySelector('.nl-product-video-sound');
    if (soundBtn) {
      container.insertBefore(btn, soundBtn);
    } else {
      container.appendChild(btn);
    }
    return btn;
  }

  function getImgContainer(productViewImageEl) {
    return productViewImageEl.querySelector('.productView-img-container');
  }

  function getYoutubePlayerFromContainer($container) {
    var $slide = $container.closest('.slick-slide');
    if ($slide.length) {
      return $slide.data('youtube-player');
    }
    return null;
  }

  function playMuted(containerEl) {
    var $c = $(containerEl);
    var video = $c.find('.productView-video.mp4 video')[0];

    if (video) {
      video.muted = true;
      video.play().catch(function () {});
      return;
    }

    function tryYoutube() {
      var yt = getYoutubePlayerFromContainer($c);
      if (yt && typeof yt.playVideo === 'function') {
        try {
          yt.mute();
          yt.playVideo();
        } catch (err) {}
        return true;
      }
      return false;
    }

    if (!tryYoutube()) {
      var tries = 0;
      var timer = setInterval(function () {
        if (tryYoutube() || ++tries > 35) {
          clearInterval(timer);
        }
      }, 100);
    }

    var vim = $c.find('.productView-video.vimeo iframe')[0];
    if (vim && vim.contentWindow) {
      try {
        vim.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), '*');
        vim.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
      } catch (e) {}
    }
  }

  function pauseAndResetSound(containerEl) {
    var $c = $(containerEl);
    var video = $c.find('.productView-video.mp4 video')[0];

    if (video) {
      video.pause();
      video.muted = true;
    }

    var yt = getYoutubePlayerFromContainer($c);
    if (yt && typeof yt.pauseVideo === 'function') {
      try {
        yt.pauseVideo();
        yt.mute();
      } catch (err) {}
    }

    var vim = $c.find('.productView-video.vimeo iframe')[0];
    if (vim && vim.contentWindow) {
      try {
        vim.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
      } catch (e) {}
    }

    var btn = $c.find('.nl-product-video-sound')[0];
    if (btn) {
      updateSoundButton(btn, true);
    }
  }

  function shouldObserveSlide(slide) {
    if (!slide.querySelector('.productView-video')) return false;
    var slickSlide = slide.closest('.slick-slide');
    if (slickSlide && slickSlide.classList.contains('slick-cloned')) return false;
    return true;
  }

  function setupVisibilityObserver() {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    if (visibilityObserver) {
      visibilityObserver.disconnect();
    }

    visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var slide = entry.target;
          var container = getImgContainer(slide);
          if (!container || !slide.querySelector('.productView-video')) return;

          var ratio = entry.intersectionRatio;
          var visibleEnough = entry.isIntersecting && ratio >= VISIBILITY_THRESHOLD;

          if (visibleEnough) {
            playMuted(container);
          } else {
            pauseAndResetSound(container);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.1, 0.2, 0.25, 0.33, 0.5, 0.75, 1]
      }
    );

    document.querySelectorAll('.productView-image').forEach(function (slide) {
      if (!shouldObserveSlide(slide)) return;
      visibilityObserver.observe(slide);
    });
  }

  function initProductVideos() {
    document.querySelectorAll('.productView-image').forEach(function (slide) {
      if (!slide.querySelector('.productView-video')) return;
      var container = getImgContainer(slide);
      if (container) {
        ensureSoundBtn(container);
        ensureFullscreenBtn(container);
        var v = container.querySelector('.productView-video.mp4 video');
        if (v) {
          v.muted = true;
          try {
            v.pause();
          } catch (err) {}
        }
      }
    });

    setupVisibilityObserver();
  }

  function getYoutubePlayerFromButton(btn) {
    var $slide = $(btn).closest('.slick-slide');
    if ($slide.length) {
      return $slide.data('youtube-player');
    }
    return null;
  }

  function toggleVimeoSound(iframe, wantSound) {
    if (!iframe || !iframe.contentWindow) return;
    try {
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: wantSound ? 1 : 0 }), '*');
    } catch (e) {}
  }

  function videoFullscreenCloseLabel() {
    return (
      (window.nlProductMedia && window.nlProductMedia.videoFullscreenCloseLabel) ||
      'Fermer'
    );
  }

  function closeNlVideoFullscreenOverlay() {
    var overlay = document.querySelector('.nl-video-fs-overlay');
    if (!overlay) return;
    var container = overlay.nlFsGalleryContainer;
    if (nlFsEscListener) {
      document.removeEventListener('keydown', nlFsEscListener);
      nlFsEscListener = null;
    }
    document.body.classList.remove('nl-video-fs-open');
    overlay.remove();
    if (container && container.nodeType === 1) {
      playMuted(container);
      var sb = container.querySelector('.nl-product-video-sound');
      if (sb) updateSoundButton(sb, true);
    }
  }

  /** Tap plein écran : la cible réelle doit être la zone vidéo / jaquette, pas une simple image (.media sans has-video). */
  function nlPvTapTargetIsVideoMedia(topEl) {
    if (!topEl || typeof topEl.closest !== 'function') return false;
    if (topEl.closest('.nl-product-video-fullscreen') || topEl.closest('.nl-product-video-sound')) {
      return false;
    }
    if (topEl.closest('.productView-video.mp4')) return true;
    if (topEl.tagName === 'VIDEO' && topEl.closest('.productView-nav')) return true;
    var media = topEl.closest('.media');
    if (media && media.classList.contains('has-video')) return true;
    return false;
  }

  function openNlVideoFullscreenOverlay(videoEl, containerEl) {
    if (!videoEl || document.querySelector('.nl-video-fs-overlay')) return;

    try {
      videoEl.pause();
    } catch (pe) {}

    var overlay = document.createElement('div');
    overlay.className = 'nl-video-fs-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.nlFsGalleryContainer = containerEl;

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'nl-video-fs-overlay__close';
    closeBtn.setAttribute('aria-label', videoFullscreenCloseLabel());
    closeBtn.innerHTML = ICON_CLOSE_OVERLAY;

    var stage = document.createElement('div');
    stage.className = 'nl-video-fs-overlay__stage';

    var clone = videoEl.cloneNode(true);
    clone.removeAttribute('id');
    clone.muted = false;
    clone.controls = true;
    clone.loop = !!videoEl.loop;
    clone.playsInline = true;
    try {
      clone.currentTime = videoEl.currentTime;
    } catch (ctErr) {}

    clone.style.pointerEvents = 'none';

    var tapExit = document.createElement('div');
    tapExit.className = 'nl-video-fs-overlay__tap-exit';
    tapExit.setAttribute('aria-hidden', 'true');

    stage.appendChild(tapExit);
    stage.appendChild(clone);
    overlay.appendChild(closeBtn);
    overlay.appendChild(stage);

    function closeFromTap(ev) {
      if (ev.type === 'touchend') {
        ev.preventDefault();
      }
      ev.stopPropagation();
      closeNlVideoFullscreenOverlay();
    }

    tapExit.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeNlVideoFullscreenOverlay();
      },
      true
    );
    tapExit.addEventListener('touchend', closeFromTap, { passive: false });

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeNlVideoFullscreenOverlay();
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeNlVideoFullscreenOverlay();
      }
    });

    nlFsEscListener = function (e) {
      if (e.key === 'Escape') {
        closeNlVideoFullscreenOverlay();
      }
    };
    document.addEventListener('keydown', nlFsEscListener);

    document.body.classList.add('nl-video-fs-open');
    document.body.appendChild(overlay);

    clone.play().catch(function () {});
  }

  function activateSoundForGallery(containerEl) {
    var $wrap = $(containerEl);
    var btn = $wrap.find('.nl-product-video-sound')[0];
    var video = $wrap.find('.productView-video.mp4 video')[0];
    if (video) {
      video.muted = false;
      if (btn) updateSoundButton(btn, false);
      return;
    }
    var yt = getYoutubePlayerFromContainer($wrap);
    if (yt && typeof yt.unMute === 'function') {
      try {
        yt.unMute();
      } catch (yErr) {}
      if (btn) updateSoundButton(btn, false);
      return;
    }
    var vimeoIframe = $wrap.find('.productView-video.vimeo iframe')[0];
    if (vimeoIframe) {
      toggleVimeoSound(vimeoIframe, true);
      if (btn) updateSoundButton(btn, false);
    }
  }

  function enterFullscreenFromContainer(containerEl) {
    if (!containerEl || document.querySelector('.nl-video-fs-overlay')) return;

    var $wrap = $(containerEl);
    var fancyOn =
      typeof $.fancybox === 'function' &&
      window.nlProductMedia &&
      window.nlProductMedia.galleryUsesFancybox === true;
    var lbSrc = fancyOn ? resolveFullscreenLightboxSrc(containerEl) : null;

    var fancyboxOpts = {
      loop: false,
      thumbs: { autoStart: false },
      buttons: ['close'],
      smallBtn: true,
      toolbar: false,
      keyboard: true,
      animationEffect: 'fade',
      transitionEffect: 'fade',
      mobile: {
        clickSlide: 'close',
        clickOutside: 'close'
      },
      afterShow: function (instance, current) {
        var $c = current && current.$content;
        if (!$c || !$c.length) return;
        var vid = $c.find('video')[0];
        if (!vid || vid.getAttribute('data-nl-fs-tap') === '1') return;
        vid.setAttribute('data-nl-fs-tap', '1');

        var parent = vid.parentNode;
        if (!parent) return;

        var holder = document.createElement('div');
        holder.className = 'nl-fancybox-video-tap-wrap';
        parent.insertBefore(holder, vid);
        holder.appendChild(vid);

        var tap = document.createElement('div');
        tap.className = 'nl-fancybox-video-tap-exit';
        tap.setAttribute('aria-hidden', 'true');
        holder.appendChild(tap);

        vid.style.pointerEvents = 'none';
        vid.muted = false;
        vid.play().catch(function () {});

        function closeFb(ev) {
          if (ev.type === 'touchend') ev.preventDefault();
          ev.stopPropagation();
          nlFsGestureDebounced(function () {
            $.fancybox.close();
          });
        }

        tap.addEventListener(
          'click',
          function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            nlFsGestureDebounced(function () {
              $.fancybox.close();
            });
          },
          true
        );
        tap.addEventListener('touchend', closeFb, { passive: false });
      },
      afterClose: function () {
        pauseAndResetSound(containerEl);
      }
    };

    var video = $wrap.find('.productView-video.mp4 video')[0];
    if (video) {
      try {
        video.pause();
      } catch (ve) {}
      if (fancyOn && lbSrc) {
        $.fancybox.open([{ src: lbSrc }], fancyboxOpts);
        return;
      }
      openNlVideoFullscreenOverlay(video, containerEl);
      return;
    }

    var iframe = $wrap.find('.productView-video iframe')[0];
    if (iframe) {
      activateSoundForGallery(containerEl);
      if (fancyOn && lbSrc) {
        $.fancybox.open([{ src: lbSrc }], fancyboxOpts);
        return;
      }
      if (typeof iframe.webkitEnterFullscreen === 'function') {
        try {
          iframe.webkitEnterFullscreen();
        } catch (ifrErr) {}
      }
      return;
    }

    if (lbSrc && typeof $.fancybox === 'function') {
      $.fancybox.open([{ src: lbSrc }], fancyboxOpts);
    }
  }

  /** Tap sur la vidéo galerie : Slick / stacking cassent les hits sur une div overlay. */
  var nlPvTouchStart = null;
  var nlGalleryPointerInstalled = false;

  function nlPvNormalizeTarget(el) {
    if (!el) return null;
    if (el.nodeType === 3 && el.parentElement) return el.parentElement;
    return el.nodeType === 1 ? el : null;
  }

  /** Bandeau vignettes : ne jamais traiter ce gestionnaire (sinon conflit asNavFor / slickGoTo mobile). */
  function nlPvIsThumbnailStrip(el) {
    if (!el || typeof el.closest !== 'function') return false;
    return !!el.closest('.productView-thumbnail-wrapper');
  }

  /**
   * @param {number} clientX
   * @param {number} clientY
   * @param {Event} origEv
   * @param {EventTarget|null} preferredTarget — cible du touchstart ou e.target au clic (fiabilise après Slick / animation)
   */
  function nlPvTryOpenFullscreenAt(clientX, clientY, origEv, preferredTarget) {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.nl-video-fs-overlay')) return;
    if (document.querySelector('.fancybox-container')) return;

    /* Menu mobile ou drawer ouvert : éviter que le hit-test vidéo (elementsFromPoint / fallback rect) ne vole le clic. */
    if (document.body.classList.contains('menu_open')) return;
    if (document.body.classList.contains('overflow-hidden-mobile')) return;
    if (document.querySelector('details.menu-drawer-container[open]')) return;
    if (document.querySelector('menu-drawer details[open]')) return;

    try {
      if (typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 990px)').matches) {
        return;
      }
    } catch (mqe) {}

    var probeThumb = nlPvNormalizeTarget(preferredTarget);
    if (!probeThumb || !document.body.contains(probeThumb)) {
      try {
        probeThumb = document.elementFromPoint(clientX, clientY);
      } catch (probeErr) {
        probeThumb = null;
      }
    }
    if (probeThumb && nlPvIsThumbnailStrip(probeThumb)) {
      return;
    }

    /** Strictement dans la zone du carousel principal (exclut header + bandeau vignettes). */
    var boundsEl =
      document.querySelector('.productView-images-wrapper .productView-nav .slick-list') ||
      document.querySelector('.productView-images-wrapper .productView-nav .slick-track') ||
      document.querySelector('.productView-images-wrapper .productView-nav');
    if (!boundsEl || typeof boundsEl.getBoundingClientRect !== 'function') return;
    var br = boundsEl.getBoundingClientRect();
    var inset = 1;
    if (
      clientX < br.left + inset ||
      clientX > br.right - inset ||
      clientY < br.top + inset ||
      clientY > br.bottom - inset ||
      br.width < 40 ||
      br.height < 40
    ) {
      return;
    }

    if (typeof document.elementsFromPoint !== 'function') return;

    var stack = document.elementsFromPoint(clientX, clientY);
    if (!stack || !stack.length) return;

    var k = 0;
    for (k = 0; k < Math.min(14, stack.length); k++) {
      var chrome = stack[k];
      if (!chrome || typeof chrome.closest !== 'function') continue;
      if (
        chrome.closest('.productView-thumbnail-wrapper') ||
        chrome.closest('.productView-for') ||
        chrome.closest('header') ||
        chrome.closest('[role="banner"]') ||
        chrome.closest('#shopify-section-header') ||
        chrome.closest('.shopify-section-header') ||
        chrome.closest('[id^="shopify-section-header"]') ||
        chrome.closest('menu-drawer') ||
        chrome.closest('.menu-drawer') ||
        chrome.closest('.menu-drawer__navigation') ||
        chrome.closest('#navigation-mobile') ||
        chrome.closest('.halo-sidebar_menu') ||
        chrome.closest('#halo-sidebar') ||
        chrome.closest('[data-navigation-mobile]')
      ) {
        return;
      }
    }

    for (k = 0; k < stack.length; k++) {
      var hit = stack[k];
      if (!hit || typeof hit.closest !== 'function') continue;
      if (hit.closest('.nl-product-video-sound') || hit.closest('.nl-product-video-fullscreen')) {
        return;
      }
      if (hit.closest('.nl-video-fs-overlay')) return;
    }

    var hitsNav = false;
    for (k = 0; k < Math.min(28, stack.length); k++) {
      var ne = stack[k];
      if (ne && ne.closest && ne.closest('.productView-nav')) {
        hitsNav = true;
        break;
      }
    }
    if (!hitsNav) return;

    /*
     * Cible : préférer l’élément du touchstart / du clic (e.target).
     * Au touchend, elementFromPoint peut viser un autre slide si Slick a bougé entre-temps — d’où la vidéo
     * qui se lançait en tapant une image.
     */
    var topEl = nlPvNormalizeTarget(preferredTarget);
    if (!topEl || !document.body.contains(topEl)) {
      try {
        topEl = document.elementFromPoint(clientX, clientY);
      } catch (efpErr) {
        return;
      }
    }
    if (!topEl || typeof topEl.closest !== 'function') return;

    var container = topEl.closest('.productView-img-container');
    if (!container || !container.closest('.productView-nav') || !container.closest('.productView-container')) {
      return;
    }

    var slideEl = container.closest('.slick-slide');
    if (slideEl && slideEl.classList.contains('slick-slide') && !slideEl.classList.contains('slick-active')) {
      return;
    }

    if (!nlPvTapTargetIsVideoMedia(topEl)) return;

    var wrap = container.querySelector('.productView-video.mp4');
    if (!wrap || !wrap.querySelector('video')) return;

    if (origEv) {
      if (origEv.cancelable) origEv.preventDefault();
      origEv.stopPropagation();
    }

    nlFsGestureDebounced(function () {
      enterFullscreenFromContainer(container);
    });
  }

  function installNlGalleryVideoTapFullscreen() {
    if (nlGalleryPointerInstalled) return;
    nlGalleryPointerInstalled = true;

    document.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        var t = e.touches[0];
        var targetEl = null;
        try {
          targetEl = document.elementFromPoint(t.clientX, t.clientY);
        } catch (iefp) {}
        nlPvTouchStart = {
          x: t.clientX,
          y: t.clientY,
          time: Date.now(),
          targetEl: nlPvNormalizeTarget(targetEl)
        };
      },
      { passive: true, capture: true }
    );

    document.addEventListener(
      'touchcancel',
      function () {
        nlPvTouchStart = null;
      },
      true
    );

    document.addEventListener(
      'touchend',
      function (e) {
        if (!nlPvTouchStart || !e.changedTouches.length) {
          nlPvTouchStart = null;
          return;
        }
        var t = e.changedTouches[0];
        var start = nlPvTouchStart;
        var dx = Math.abs(t.clientX - start.x);
        var dy = Math.abs(t.clientY - start.y);
        var dt = Date.now() - start.time;
        nlPvTouchStart = null;
        if (dx > 32 || dy > 32 || dt > 1100) return;

        nlPvTryOpenFullscreenAt(t.clientX, t.clientY, e, start.targetEl);
      },
      { capture: true, passive: false }
    );

    document.addEventListener(
      'click',
      function (e) {
        nlPvTryOpenFullscreenAt(e.clientX, e.clientY, e, e.target);
      },
      true
    );
  }

  $(document).on('click', '.nl-product-video-fullscreen', function (e) {
    e.preventDefault();
    e.stopPropagation();
    enterFullscreenFromContainer($(this).closest('.productView-img-container')[0]);
  });

  $(document).on('click', '.nl-product-video-sound', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var btn = this;
    var $wrap = $(btn).closest('.productView-img-container');
    var video = $wrap.find('.productView-video.mp4 video')[0];

    if (video) {
      video.muted = !video.muted;
      updateSoundButton(btn, video.muted);
      return;
    }

    var yt = getYoutubePlayerFromButton(btn);
    if (yt && typeof yt.unMute === 'function') {
      try {
        var ytMuted = btn.classList.contains('nl-product-video-sound--muted');
        if (ytMuted) {
          yt.unMute();
          updateSoundButton(btn, false);
        } else {
          yt.mute();
          updateSoundButton(btn, true);
        }
      } catch (err) {
        yt.unMute();
        updateSoundButton(btn, false);
      }
      return;
    }

    var vimeoIframe = $wrap.find('.productView-video.vimeo iframe')[0];
    if (vimeoIframe) {
      var soundOff = btn.classList.contains('nl-product-video-sound--muted');
      toggleVimeoSound(vimeoIframe, soundOff);
      updateSoundButton(btn, !soundOff);
    }
  });

  $(function () {
    installNlGalleryVideoTapFullscreen();
    initProductVideos();

    setTimeout(initProductVideos, 800);
    setTimeout(initProductVideos, 2000);

    $(document).on('reInit afterChange', '.productView-nav', function () {
      setTimeout(initProductVideos, 0);
    });
  });
})(window.jQuery);
